import React from "react";
import MUIDataTable, {MUIDataTableOptions} from "mui-datatables";
import {
    APOLLO_PAGE_ID,
    ApolloPageId,
    createApolloPageSizeTableOptions,
} from "../common/Apollo_LocalStorageSettings";


export interface DataTableProps {
    children?: React.ReactNode;
    title: any;
    data: any;
    columns: any;
    options: any;
}

export function ApolloDataTable(props: DataTableProps) {
    const {title, data, columns, options} = props;
    const pageId = options?.apolloPageId ?? (options?.storageKey ? PAGE_SIZE_STORAGE_KEY_MAP[options.storageKey] : undefined);
    const tableOptions = pageId ? createApolloPageSizeTableOptions(options, pageId) : options;

    return (
        <MUIDataTable
            title={title}
            data={data ? data : []}
            columns={columns}
            options={tableOptions}
        />
    );
}

export interface DataTableOptions extends MUIDataTableOptions {
    storageKey?: string;
    apolloPageId?: ApolloPageId;
};

export const STORAGE_KEY = {
    SELECT_ACCOUNT: "SelectAccount_DataTable",
    APOLLO_ACCOUNT_GROUP_LIST: "ApolloAccountGroupList_DataTable",
    APOLLO_ACCOUNT_LIST: "ApolloAccountList_DataTable",
    APOLLO_UNAPPROVED_ACCOUNT_LIST: "ApolloUnapprovedAccountList_DataTable",
    APOLLO_IMAGE_DIALOG: "ApolloImageDialog_DataTable",
    APOLLO_ROLE: "ApolloRole_DataTable",
    APOLLO_USER_LIST: "ApolloUserList_DataTable",
    APOLLO_USER: "ApolloUser_DataTable",
    CUSTOM_SEGMENT: "CustomSegment_DataTable",
    GEO_SEGMENT: "GeoSegment_DataTable",
    USER_LIST: "UserList_DataTable",
    ZEUS_AD_GROUP_LIST: "ZeusAdGroupList_DataTable",
    MS_AD_GROUP_LIST: "MsAdGroupList_DataTable",
    ZEUS_ADVERTISEMENTS_LIST: "ZeusAdvertisementsList_DataTable",
    MS_ADVERTISEMENTS_LIST: "MsAdvertisementsList_DataTable",
    MS_ADVERTISEMENTS_EDIT: "MsAdvertisementsEdit_DataTable",
    BUDGET: "Budget_DataTable",
    CAMPAIGN: "Campaign_DataTable",
    MS_AD_ASSETS_LIST: "MsAdAssetsList_DataTable",
    ZEUS_CR_ASSETS_LIST: "MsAdAssetsList_DataTable",
    HERA_AUDIENCES: "HeraAudiences_DataTable",
    HERA_EVENTS: "HeraEvents_DataTable",
    HERA_SET_POINTS: "HeraSetPoints_DataTable",
    IN_VOICE: "InVoice_DataTable",
    MASTER_BILLING_RESOURCES: "MasterBillingResources_DataTable",
    MASTER_INDUSTORYS: "MasterIndustorys_DataTable",
    MASTER_PRODUCTS: "MasterProducts_DataTable",
    NOTIFY: "Notify_DataTable",
    REPORT: "Report_DataTable",
    CREATED_REPORT: "CreatedReport_DataTable",
    AFFINITY_CATEGORY: "AffinityCategory_DataTable",
    GEO_SEGMENT_ALL: "GeoSegmentAll_DataTable",
    SEGMENT: "Segment_DataTable",
    ACCOUNT_SUMMARY: "AccountSummary_DataTable",
    INDIVIDUAL_SUMMARY: "IndividualSummary_DataTable",
    OPERATION_HISTORY: "OperationHistory_DataTable",
    APOLLO_AD_CLIENT_ICON: "ApolloAdClientIcon_DataTable",
    APOLLO_UNAPPROVED_AD_CLIENT_ICON: "ApolloUnApprovedAdClientIcon_DataTable",
    APOLLO_APPROVED_AD_CLIENT_ICON: "ApolloApprovedAdClientIcon_DataTable",
    APOLLO_CREATIVE_DIALOG: "ApolloCreativeDialog_DataTable",
}

const PAGE_SIZE_STORAGE_KEY_MAP: {[key: string]: ApolloPageId} = {
    [STORAGE_KEY.SELECT_ACCOUNT]: APOLLO_PAGE_ID.ACCOUNT_SELECT_HEADER_MENU,
    [STORAGE_KEY.APOLLO_ACCOUNT_GROUP_LIST]: APOLLO_PAGE_ID.ACCOUNT_GROUP_LIST,
    [STORAGE_KEY.APOLLO_ACCOUNT_LIST]: APOLLO_PAGE_ID.ACCOUNT_GROUP_ACCOUNTS,
    [STORAGE_KEY.APOLLO_UNAPPROVED_ACCOUNT_LIST]: APOLLO_PAGE_ID.UNAPPROVED_ACCOUNT_GROUP_LIST,
    [STORAGE_KEY.APOLLO_ROLE]: APOLLO_PAGE_ID.ROLE_LIST,
    [STORAGE_KEY.APOLLO_USER_LIST]: APOLLO_PAGE_ID.ACCOUNT_GROUP_USERS,
    [STORAGE_KEY.APOLLO_USER]: APOLLO_PAGE_ID.USER_LIST,
    [STORAGE_KEY.CUSTOM_SEGMENT]: APOLLO_PAGE_ID.CUSTOM_SEGMENT_LIST,
    [STORAGE_KEY.BUDGET]: APOLLO_PAGE_ID.BUDGET,
    [STORAGE_KEY.HERA_AUDIENCES]: APOLLO_PAGE_ID.AUDIENCE_LIST,
    [STORAGE_KEY.HERA_EVENTS]: APOLLO_PAGE_ID.EVENT_LIST,
    [STORAGE_KEY.HERA_SET_POINTS]: APOLLO_PAGE_ID.SET_POINT_LIST,
    [STORAGE_KEY.IN_VOICE]: APOLLO_PAGE_ID.FIXED_BILLING_AMOUNT_LIST,
    [STORAGE_KEY.MASTER_BILLING_RESOURCES]: APOLLO_PAGE_ID.BILLING_RESOURCE_MASTER,
    [STORAGE_KEY.MASTER_PRODUCTS]: APOLLO_PAGE_ID.PRODUCT_MASTER,
    [STORAGE_KEY.NOTIFY]: APOLLO_PAGE_ID.NOTIFY_MESSAGE_LIST,
    [STORAGE_KEY.CREATED_REPORT]: APOLLO_PAGE_ID.REPORT_DETAIL,
    [STORAGE_KEY.AFFINITY_CATEGORY]: APOLLO_PAGE_ID.AFFINITY_CATEGORY_LIST,
    [STORAGE_KEY.OPERATION_HISTORY]: APOLLO_PAGE_ID.OPERATION_HISTORY,
    [STORAGE_KEY.APOLLO_AD_CLIENT_ICON]: APOLLO_PAGE_ID.AD_CLIENT_ICON_LIST,
    [STORAGE_KEY.APOLLO_UNAPPROVED_AD_CLIENT_ICON]: APOLLO_PAGE_ID.AD_CLIENT_ICON_REVIEW_LIST,
    [STORAGE_KEY.APOLLO_APPROVED_AD_CLIENT_ICON]: APOLLO_PAGE_ID.AD_CLIENT_ICON_APPROVED_REVIEW_LIST,
    [STORAGE_KEY.MS_ADVERTISEMENTS_EDIT]: APOLLO_PAGE_ID.AD_EDIT_MS,
    [STORAGE_KEY.MS_AD_ASSETS_LIST]: APOLLO_PAGE_ID.AD_ASSET_LIST_MS,
    [STORAGE_KEY.APOLLO_CREATIVE_DIALOG]: APOLLO_PAGE_ID.AD_ASSET_LIST_ZEUS,
}
